export default "__VITE_ASSET__DaD81paB__"